import { InboxIcon } from "lucide-react";

interface EmptyStateProps {
  message?: string;
}

export function EmptyState({
  message = "No data for this time range",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-fg-muted">
      <InboxIcon className="h-10 w-10 mb-3 opacity-50" />
      <p className="text-sm">{message}</p>
    </div>
  );
}
